import { posthog } from "posthog-js";
export var LoggingId;
(function (LoggingId) {
    LoggingId["ONBOARDING_FORM_FOOTER_SIGN_IN_WITH_DIFFERENT_ACCOUNT_BUTTON_CLICK"] = "ONBOARDING_FORM_FOOTER_SIGN_IN_WITH_DIFFERENT_ACCOUNT_BUTTON_CLICK";
    LoggingId["ONBOARDING_FORM_FOOTER_GO_BACK_BUTTON_CLICK"] = "ONBOARDING_FORM_FOOTER_GO_BACK_BUTTON_CLICK";
    LoggingId["ONBOARDING_FORM_FOOTER_COMPLETE_BUTTON_CLICK"] = "ONBOARDING_FORM_FOOTER_COMPLETE_BUTTON_CLICK";
    LoggingId["ONBOARDING_FORM_FOOTER_CONTINUE_BUTTON_CLICK"] = "ONBOARDING_FORM_FOOTER_CONTINUE_BUTTON_CLICK";
    LoggingId["CREATE_SOURCE_SELECTOR_SOURCE_TYPE_SELECTED"] = "CREATE_SOURCE_SELECTOR_SOURCE_TYPE_SELECTED";
    LoggingId["SOURCES_CREATE_SOURCE_SELECTOR_SOURCE_TYPE_SELECTED"] = "SOURCES_CREATE_SOURCE_SELECTOR_SOURCE_TYPE_SELECTED";
})(LoggingId || (LoggingId = {}));
export const posthogLog = (id, properties) => {
    posthog.capture(id.toString(), properties);
};
